<template>
  <!-- 数据可视化大屏跳转按钮 -->
  <button class="dashboard-btn" @click="goToDashboard">
    <i class="icon">📋</i>
    <span class="btn-text">数据可视化</span>
  </button>
  <!-- 页面主体内容 -->
  <div class="content-wrapper">
    <!-- TODO:logo更换-->
    <div class="title">
      <img :src="require('../../assets/logo1.png')" alt="网站logo" class="logo" />
      <h1 class="main-title">{{$platformName }}</h1>
    </div>
    <div class="navbar-container">
      <!-- Element Plus导航菜单组件 -->
      <el-menu mode="horizontal" router :default-active="$route.path" active-text-color="#165DFF"
        background-color="transparent" text-color="#333" class="custom-navbar" :collapse="false"
        :collapse-transition="false" :ellipsis="false" >
        <el-menu-item index="/" class="nav-item">
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/achievement" class="nav-item">
          <span>成果展示</span>
        </el-menu-item>
        <el-menu-item index="/techDemand" class="nav-item">
          <span>技术需求</span>
        </el-menu-item>

        <el-menu-item index="/institution" class="nav-item">
          <span>高校机构</span>
        </el-menu-item>
        <!-- <el-menu-item index="/enterprise" class="nav-item">
          <span>科研机构</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="/experts" class="nav-item">
          <span>人才智库</span>
        </el-menu-item> -->
        <el-menu-item index="/instruments" class="nav-item">
          <span>仪器共享</span>
        </el-menu-item>
        <el-menu-item index="/investmentCompanys" class="nav-item">
          <span>科技金融</span>
        </el-menu-item>
        <!-- <el-menu-item index="/news" class="nav-item">
          <span>政策资讯</span>
        </el-menu-item> -->
      </el-menu>
    </div>
  </div>
</template>
<style scoped>
/* 数据可视化大屏按钮样式 */

.dashboard-btn {
  position: fixed;
  /* 固定定位，始终在右上角 */
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  /* 确保按钮在其他内容上方 */
}

.dashboard-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.6);
  background: linear-gradient(135deg, #3a56d4, #30098f);
}

.dashboard-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(67, 97, 238, 0.4);
}

.icon {
  font-style: normal;
  font-size: 1.2rem;
}

/* 主界面样式 */
.home-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.content-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.title {
  display: flex;
  align-items: center;
}

.main-title {
  font-size: 3.5rem;
  margin: 40px;
}

/* 导航栏样式 */

.navigation {
  margin: 20px 0px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-item {
  font-size: 2rem;
  cursor: pointer;
  padding: 5px 15px;
  /* 左右增加内边距，让文字周围空间更均匀 */
  white-space: nowrap;
  /* 防止文字换行 */
}

.nav-item:hover {
  color: #0066cc;
}

.separator {
  color: #ccc;
  font-size: 1.2rem;
}

/* 导航栏容器样式 */
.navbar-container {
  display: flex;
  justify-content: center;
  padding: 0 20px;
  width: 100%;
  margin-top: 30px;
  /* border-bottom: 1px solid #eee; */
  /* 底部边框作为分隔线 */
}

/* 自定义导航栏样式 */
.custom-navbar {
  height: auto;
  /* 自动高度，适应内容 */
  line-height: normal;
  /* 正常行高 */
  padding: 10px 0;
  /* 上下内边距 */
}

/* 导航项样式 */
.nav-item {
  position: relative;
  /* 用于竖线定位 */
  margin: 0 15px;
  /* 左右间距 */
}

/* 使用深度选择器穿透 scoped 隔离 */
::v-deep .nav-item:not(:first-child)::before {
  content: '';
  position: absolute;
  left: 0; /* 调整位置，避免受父元素 padding 影响 */
  top: 50%;
  transform: translateY(-50%);
  height: 1.7rem;
  width: 1px;
  background-color: #ccc;
}

/* 鼠标悬停样式 - 覆盖Element Plus默认样式 */
:deep(.el-menu-item:not(.is-active):hover) {
  color: #165DFF !important;
  /* 鼠标悬停时的蓝色 */
}

/* 关键设置：确保菜单不换行且不折叠 */
:deep(.el-menu) {
  width: auto !important;
  /* 让菜单宽度自适应内容 */
  flex-wrap: nowrap !important;
  /* 禁止换行 */
  white-space: nowrap;
  /* 禁止文本换行 */
}

/* 移除可能的最大宽度限制 */
:deep(.el-menu) {
  max-width: none !important;
}
</style>
<script>
  export default{
    methods:{
      goToDashboard(){
        this.$router.push("/dataShow")
      }
    }
  }
</script>